/**
 * Firebase-free env flags. Kept apart from `app.ts` so code that only needs the
 * flags (analytics boot) never pulls the Firebase SDK into its chunk.
 */
/**
 * Vite injects `import.meta.env` at bundle time. Under plain `tsx` (e.g.
 * `generate:public`), `import.meta.env` is undefined — never throw on read.
 * Browser/Vite behavior is unchanged when env is present.
 */
export const viteEnv =
  (import.meta as ImportMeta & { env?: ImportMetaEnv }).env ??
  ({} as ImportMetaEnv);

export function usingFirebaseEmulators(): boolean {
  return viteEnv.VITE_USE_FIREBASE_EMULATORS === "true";
}

export const firebasePushConfig = {
  vapidKey: viteEnv.VITE_FIREBASE_VAPID_KEY ?? null,
};
